import React from 'react';
import classnames from 'classnames';

import { useStyles } from '../Seat/useStyles';

export const EmptySeat = ({ seat, maxWidth, style }) => {
    const classes = useStyles(maxWidth)();

    return (
        <article key={seat.id} className={classnames('passenger-grid__empty-seat', classes.seat)} style={style}>
            <div className="passenger-grid__empty-icon" />
            <div className="passenger-grid__seat-name"></div>
        </article>
    );
};
